export const RoutesParams = {
    token: 'token',
};

export const RoutesUrl = {
    welcome: '/',
    restPassword: '/auth/reset-password',
};
